import type { ItemType } from "@jasper/client-models";
import type { UpdateProductArgs } from "@jasper/use-cases";
import type { ConfigurableProduct } from "../types";

export const defaultApplyTeethSelection = ({
  teeth,
  product,
  itemType,
}: {
  teeth: number[];
  product: ConfigurableProduct;
  itemType: ItemType;
}): UpdateProductArgs => {
  const itemsToSave = product.items.length
    ? product.items.map(item => ({
        tooth: teeth[0],
        type: item.type,
        materialCharacteristics: item.materialCharacteristics,
        inlayCoreCharacteristics: item.inlayCoreCharacteristics,
      }))
    : [
        {
          tooth: teeth[0],
          type: itemType,
        },
      ];

  return {
    productId: product.id,
    teeth: teeth,
    items: itemsToSave,
  };
};
